import EventCard from '@components/EventCard'
import Loading from '@components/Loading'
import Carousel from '@components/Carousel'
import './EventList.css'

const EventList = ({ 
  events, 
  title,
  loading = false,
  emptyMessage = 'Nenhum evento encontrado',
}) => {
  if (loading) {
    return (
      <section className="event-list">
        {title && <h2 className="event-list__title">{title}</h2>}
        <div className="event-list__loading">
          <Loading />
        </div>
      </section>
    )
  }

  if (!events || events.length === 0) {
    return (
      <section className="event-list">
        {title && <h2 className="event-list__title">{title}</h2>}
        <div className="event-list__empty">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <p>{emptyMessage}</p>
        </div>
      </section>
    )
  }

  return (
    <section className="event-list">
      {title && <h2 className="event-list__title">{title}</h2>}
      
      <Carousel>
        {events.map((event) => (
          <EventCard 
            key={event.event_id} 
            event={event}
          />
        ))}
      </Carousel>
    </section>
  )
}

export default EventList
